import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const RevisionTable = ({
  revision,
  loading,
  vencimientoBody,
  actionBodyTemplate,
  handleRowClick,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    initFilters();
  }, []);
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return (
      <>
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
          <span className="p-input-icon-left" style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <i className="pi pi-search" />
            <InputText
              value={globalFilterValue ? globalFilterValue.toUpperCase() : ""}
              onChange={(e) => onGlobalFilterChange(e)}
              placeholder="Buscar por Cliente..."

            />
          </span>
          <h6 className="m-0" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            {revision?.length} cotizaciones
          </h6>
        </div>
      </>
  
    );
  };
  const header = renderHeader();
  return (
    <div className="col-12">
      <div className="col-12">
          <DataTable
            value={revision}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 50, 100]}
            dataKey="id"
            filters={filters}
            filterDisplay="menu"
            loading={loading}
            emptyMessage="No se encontraron Cotizaciones."
            rowClassName="row-clickable"
            onRowClick={(e) => !loading && handleRowClick(e.data)}
            header={header}
            globalFilterFields={["cliente.razonSocial"]}
            stripedRows="true"
            showGridlines
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cotizaciones"
            scrollHeight="57vh"
            scrollable
            reorderableColumns
            resizableColumns
            columnResizeMode="fit"
          >
            <Column
              field="id"
              header="Cotización"
              style={{ minWidth: "7rem" }}
              body={(rowData) => (
                <span>
                  {rowData.folio ? (
                    <><strong>Folio</strong> {rowData.folio} <br/>
                    <strong>ID</strong> {rowData.id}</>
                  ) : (
                    <><strong>ID</strong> {rowData.id}</>
                  )}
                </span>
              )}
              sortable 
              sortField="id"
            />

            <Column
              field="cliente.razonSocial"
              header="Cliente"
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.cliente.razonSocial}
              sortable
            />

            <Column
              field="fecha_creacion_cotizacion"
              header="Fecha de Creación"
              sortable
              body={(rowData) => {
                if (rowData.fecha_creacion_cotizacion) {
                  let date;
                  if (typeof rowData.fecha_creacion_cotizacion === 'string') {
                    const parts = rowData.fecha_creacion_cotizacion.split(' ');
                    if (parts.length === 6) {
                      // Drop weekday and timezone, rebuild in a parsable format
                      const [, month, day, time, , year] = parts;
                      date = new Date(`${month} ${day} ${year} ${time} GMT-0400`);
                    } else {
                      date = new Date(rowData.fecha_creacion_cotizacion);
                    }
                  } else {
                    date = new Date(rowData.fecha_creacion_cotizacion);
                  }
                  if (isNaN(date)) {
                    return "Fecha inválida";
                  }
                  return date.toLocaleDateString('es-CL', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  }).replace(/-/g, '/');
                }
                return "No tiene fecha";
              }}
            />
            
            <Column
              field="desde"
              header="Desde"
              body={(rowData) => rowData.desde || "No tiene fecha"}
              sortable
            /> 

            <Column
              field="hasta"
              header="Hasta"
              body={(rowData) => rowData.hasta || "No tiene fecha"}
              sortable
            />
            <Column
              field="estado"
              header="Estado"
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.estado || "Sin estado"}
              sortField="estado"
              sortable
            />
            <Column
              field="empresa"
              header="Empresa"
              filterMenuStyle={{ width: "14rem" }}
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.empresa}
              sortable
              sortField="empresa"
            />
            
            <Column
              field="creadorNombre"
              header="Responsable"
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.creadorNombre}
              sortable
              sortField="creadorNombre"
            />
            
            <Column
              field="Vencimiento"
              header="Vencimiento"
              style={{ minWidth: "7rem" }}
              body={vencimientoBody}
              sortable
              sortField="vencimiento"
            />

            <Column
              field="observacion"
              header="Motivo"
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.observacion}
              sortable
              sortField="observacion"
            />
            
            <Column
              header="Acción"
              body={actionBodyTemplate}
              style={{ minWidth: "12rem", textAlign: "center" }}
            /> 
          </DataTable>
      </div>
    </div>

  );
};

export default RevisionTable;
